import * as $ from 'jquery';
import 'bootstrap';
import 'slick';

export class homeSlider{
	private $scope = $('.slider-wrapper');
    
    init():void {
        this.handleNextArrow();
        this.handlePreviousArrow();
        let sliders  = this.$scope.find('ul');
        sliders.each(function(){
            if($(this).width()===this.scrollWidth){
               $(this).parents(".slider-wrapper").find('button').hide();
            }
        })
        this.handleCarousel();
    }

    handleNextArrow():void{
        let nextArrow = this.$scope.find('.seq-next');
        
        nextArrow.click(function(){

            $(this).parents('.slider-wrapper').find('.seq-prev').fadeIn();


            let items = $(this).parents('.slider-wrapper').find('ul');
            let itemWidth = items.find('li').width();
            let itemsGap = parseInt(items.find('li').css('margin-inline-end'));
            let totalWidth = itemsGap+itemWidth;
            let scrollWidth = Math.floor(items.width()/totalWidth)*totalWidth;
            items.css("scroll-snap-type", "none");
            $(items).animate({
                scrollLeft: $(items).scrollLeft()+scrollWidth,
            },500,
            () => {
                items.css("scroll-snap-type", "x mandatory");
                if(items.scrollLeft()+items.width()>=items.get(0).scrollWidth){
                    $(this).fadeOut();
                }
            });
         }
         )
    }

    handlePreviousArrow():void{
        let prevArrow = this.$scope.find('.seq-prev');
        
        prevArrow.click(function(){
            $(this).parents('.slider-wrapper').find('.seq-next').fadeIn();
            let items = $(this).parents('.slider-wrapper').find('ul');
           let itemWidth = items.find('li').width();
           let itemsGap = parseInt(items.find('li').css('margin-inline-end'));
           let totalWidth = itemsGap+itemWidth;
           let scrollWidth = Math.floor(items.width()/totalWidth)*totalWidth;
           items.css("scroll-snap-type", "none");

           if(items.scrollLeft()+items.width()>=items.get(0).scrollWidth){
            let visibleItems = Math.floor(items.width()/totalWidth)*totalWidth;
            let partialVisibleWidth = items.width()%totalWidth;
            scrollWidth = visibleItems - partialVisibleWidth - itemsGap;
            }
            
           $(items).animate({
               scrollLeft: $(items).scrollLeft()-scrollWidth
           },500,
           () => {
               items.css("scroll-snap-type", "x mandatory");
               if(items.scrollLeft()<=0){
                $(this).fadeOut();
                }
            });

           
        }
        )

    }
    handleCarousel():void{
        $('.enrich-home-container .mobile-version').on('touchmove click', function() { 
            $('.enrich-important').slick("setPosition");
        })
        $('.close-container').one('click', function() { 
            $('.enrich-important').slick("setPosition");
        })

            $('.enrich-important').slick({
                responsive: [{
                    breakpoint: 9999,
                    settings:'unslick'
                    },
                    {
                      breakpoint: 768,
                      settings: {
                        arrows:false,
                        dots: true,
                        infinite: false,
                      }
                    }
                ]
                })
        
        $(window).resize(function() {
            if($(window).width()<768){
                $('.enrich-important')[0].slick.refresh();
            }
          });
    }
    
	
}

let scope:Element = document.querySelector('.slider-wrapper');
if (scope){
	try {
		let slider = new homeSlider();
        slider.init();
	} catch(e) {console.error(e);}
}
